module.exports = __webpack_public_path__ + "asset/img/timun_logo.b935689a9040493a5d9a8a0b451dd029.png";